import type { getRouter } from '@/router';
import { EnvironmentService } from '@/services/environment';
import {
  captureException,
  init,
  tanstackRouterBrowserTracingIntegration,
  type BrowserOptions,
} from '@sentry/react';

const options: BrowserOptions = {
  dsn: 'https://8ca52039e4d2b24b0e74f3a16bce3164@o372675.ingest.us.sentry.io/4510704714383360',
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
};

export const SentryService = {
  init: (router: ReturnType<typeof getRouter>, config: BrowserOptions = {}) => {
    const isProd = process.env.NODE_ENV === 'production';
    const release = process.env.RELEASE_NAME;

    if (isProd && release) {
      EnvironmentService.getEnvironment().then((environment) => {
        if (environment === 'stage' || environment === 'production') {
          init({
            ...options,
            ...config,
            environment,
            release,
            integrations: [tanstackRouterBrowserTracingIntegration(router)],
          });
        }
      });
    }
  },
  trackError: captureException,
};
